<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 flex items-center justify-center z-60"
    @click.self="closeModal"
  >
    <div class="absolute w-full h-full bg-[#F2F1EC] opacity-50 z-30"></div>
    <div :class="['bg-white px-3 py-3 mt-5 rounded-[30px] shadow-lg z-60', width]">
      <div class="pb-2 border-b border-[#E2E8F0]">
        <div class="flex justify-between items-center px-4">
          <p class="text-[20px] font-medium">{{ title }}</p>
          <button type="button" class="cursor-pointer" @click="closeModal">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_260_1653)">
                <path
                  d="M8.28259 7.0117L13.734 1.5602C14.0887 1.20559 14.0887 0.632233 13.734 0.277672C13.3794 -0.0769322 12.806 -0.0769322 12.4515 0.277672L6.99994 5.72913L1.54861 0.277672C1.19383 -0.0769322 0.620684 -0.0769322 0.26608 0.277672C-0.0886934 0.632275 -0.0886934 1.20559 0.26608 1.5602L5.71737 7.0117L0.266123 12.4632C-0.0886509 12.8178 -0.0886509 13.3911 0.266123 13.7457C0.350236 13.83 0.450189 13.8969 0.560238 13.9425C0.670287 13.9881 0.788262 14.0116 0.907386 14.0114C1.13954 14.0114 1.37177 13.9226 1.54865 13.7457L6.99994 8.29422L12.4515 13.7457C12.5356 13.83 12.6356 13.8969 12.7456 13.9425C12.8556 13.9881 12.9736 14.0115 13.0927 14.0114C13.3249 14.0114 13.5571 13.9226 13.734 13.7457C14.0887 13.3911 14.0887 12.8178 13.734 12.4632L8.28259 7.0117Z"
                  fill="#3B3B3B"
                />
              </g>
              <defs>
                <clipPath id="clip0_260_1653">
                  <rect width="14" height="14" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>
      </div>
      <div class="px-4 flex flex-col max-h-[68dvh] overflow-auto">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    title: String,
    width: {
      type: String,
      default: "w-11/12 md:w-6/12 xl:w-5/12", // Default Tailwind width classes
    },
  },
  emits: ["close"],
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.close-btn {
  padding: 0.5rem 1rem;
  background: gray;
  color: white;
  border-radius: 6px;
  cursor: pointer;
}

.close-btn:hover {
  background: darkgray;
}
</style>
